export type RouteUserType = 'internal' | 'client' | 'rep' | 'parent_admin' | 'unknown';

const USER_TYPE_ALIASES: Record<string, RouteUserType> = {
  admin: 'internal',
  super_admin: 'internal',
  internal: 'internal',
  client: 'client',
  client_rep: 'rep',
  rep: 'rep',
  parent_admin: 'parent_admin',
  parentadmin: 'parent_admin',
};

export const normalizeUserType = (userType?: string | null): RouteUserType => {
  if (!userType) {
    return 'unknown';
  }

  const key = userType.trim().toLowerCase().replace(/-/g, '_');
  return USER_TYPE_ALIASES[key] ?? 'unknown';
};

export const getAuthenticatedLandingPath = (
  user?: { userType?: string | null } | null
): string | null => {
  switch (normalizeUserType(user?.userType)) {
    case 'internal':
      return '/org-select';
    case 'client':
      return '/client/dashboard';
    case 'rep':
      return '/rep/dashboard';
    case 'parent_admin':
      // Parent admins use the same client portal as a regular CLIENT
      // login. The backend aggregates data across every child clinic
      // (orders, etc.) so the existing dashboard renders the union of
      // their portfolio with no parallel UI. Place-order is the only
      // surface that asks "which clinic" -- it does so inline.
      return '/client/dashboard';
    default:
      return null;
  }
};
